<script setup lang="ts">
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import TableCell from './TableCell.vue';
  import TableRow from './TableRow.vue';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      colspan?: number;
    }>(),
    {
      colspan: 1,
    },
  );

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });
</script>

<template>
  <TableRow data-slot="table-empty" class="bg-transparent!">
    <TableCell
      :class="cn('p-4 whitespace-nowrap align-middle text-sm text-foreground', props.class)"
      v-bind="delegatedProps"
    >
      <div class="flex items-center justify-center py-10">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>
